import { BID_STATUS, PostAcceptanceBidStatusList } from "@vahak/core/dist/constants/bidStatus";

export const getRequiredBid = <T extends { status?: number | null }>(bids?: T[] | null) =>
    bids?.find(
        (bid) => bid.status != null && PostAcceptanceBidStatusList.includes(bid.status as BID_STATUS)
    );
